import { useParams, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Row, Col, Table } from 'react-bootstrap';

// Custom decoding for Safari compatibility
const dereplaceSpecialChars = (str) => {
    if (!str) return str;
    return str
        .replace(/__e__/g, 'ê')
        .replace(/__c__/g, 'ç')
        .replace(/__a1__/g, 'á')
        .replace(/__a2__/g, 'à')
        .replace(/__a3__/g, 'â')
        .replace(/__a4__/g, 'ã')
        .replace(/__e1__/g, 'é')
        .replace(/__e2__/g, 'è')
        .replace(/__o1__/g, 'ó')
        .replace(/__o2__/g, 'ò')
        .replace(/__o3__/g, 'õ')
        .replace(/__o4__/g, 'ô')
        .replace(/__i1__/g, 'í')
        .replace(/__u1__/g, 'ú')
        .replace(/__u2__/g, 'ü');
};

export default function Licitacao() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { id } = useParams();
    const [licitacao, setLicitacao] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    // Decode query parameters if they exist
    const modalidade = queryParams.get('modalidade') ? dereplaceSpecialChars(queryParams.get('modalidade')) : null;
    const status = queryParams.get('status') ? dereplaceSpecialChars(queryParams.get('status')) : null;

    useEffect(() => {
        if (!id) return;

        setLoading(true);
        setError(false); // limpa erro anterior

        fetch(`https://www.alepe.pe.gov.br/licitacoes/list.php?v=2&ID=${id}`)
            .then(res => res.json())
            .then(json => {
                if (json?.data?.length > 0) {
                    setLicitacao(json.data[0]);
                } else {
                    setLicitacao(null);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error('Erro na requisição:', err);
                setError(true);
                setLoading(false);
            });
    }, [id]);


    if (loading) return <div>Carregando...</div>;

    if (error) return <div>Erro ao carregar os dados. Tente novamente mais tarde.</div>;

    if (!licitacao) return <div>Licitação não encontrada.</div>;


    return <div>
        <p><small>Você está em <a href="/financas">Prestação de Contas</a> / <a href="/financas/licitacoes">Licitações</a> / {`${licitacao.NOMEMODALIDADE} ${licitacao.NUMEROMODALIDADE}/${licitacao.ANOMODALIDADE}`}</small></p>
        <Row>
            <Col xs="12" className="text-center">
                <h2>{`${licitacao.NOMEMODALIDADE} ${licitacao.NUMEROMODALIDADE}/${licitacao.ANOMODALIDADE}`}</h2>.
            </Col>
            <Col xs="12" className="text-center">
                <h2 style={{ fontSize: '80%' }}>{`Processo ${licitacao.NUMEROPROCESSO}/${licitacao.ANOPROCESSO}`}</h2>
            </Col>
            <Col xs="12" className='mt-3'>
                <div className="proposicao-list-item-header">
                    <h3>Objeto conforme Edital</h3>
                </div>
                <div className="proposicao-list-item-text">
                    <p style={{ textAlign: 'justify' }}>{licitacao.OBJETOCONFORMEEDITAL}</p>
                </div>
            </Col>
            <Col xs="12" className='mt-3 mb-5 table-responsive>'>
                <h3>Informações</h3>
                <Table>
                    <tbody>
                        <tr>
                            <td><strong>STATUS:</strong></td>
                            <td style={{ minWidth: '585px' }}>{licitacao.SITUACAOLICITACAO || '-'}</td>
                        </tr>
                        <tr>
                            <td><strong>Data de Abertura:</strong></td>
                            <td style={{ minWidth: '585px' }}>
                                {licitacao.DATASESSAOABERTURA ? new Date(licitacao.DATASESSAOABERTURA.date).toLocaleDateString() : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Vencedor:</strong></td>
                            <td style={{ minWidth: '585px' }}>{licitacao.RAZAOSOCIAL || '-'}</td>
                        </tr>
                        <tr>
                            <td><strong>CPF/CNPJ:</strong></td>
                            <td>{licitacao.NUMERODOCUMENTOAJUSTADO || '-'}</td>
                        </tr>
                        <tr>
                            <td><strong>Valor Adjudicado:</strong></td>
                            <td>
                            {licitacao.TOTALADJUDICADOLICITANTE !== undefined
                                ? licitacao.TOTALADJUDICADOLICITANTE.toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                })
                                : '-'}
                            </td>

                        </tr>
                        <tr>
                            <td><strong>Anexos:</strong></td>
                            <td>
                                {licitacao.LinkArquivo && (
                                <a href={licitacao.LinkArquivo.replace("http://sistemas.tce.pe.gov.br/audinArquivos/licon/processo_licitatorio/edital/778/", "https://www.alepe.pe.gov.br/licitacoes/downloads/")} target="_blank" rel="noopener noreferrer">
                                    Visualizar em PDF
                                </a>
                                )}
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Col>
        </Row>
    </div>;
}